import React from 'react';

const TagNames = ({ items = [], history }) => {
  let tagNames = items.map((item, i) => (
    <span
      key={'item' + i}
      style={{
        color: 'rgba(0,0,0,0.87)',
        fontSize: '1.089375rem',
        fontWeight: '400',
        fontFamily: '"Catamaran","Roboto","Helvetica","Aerial,"sans-serif"',
      }}
    >
      <u style={{ textDecoration: 'none' }}>{item}</u>
      <span>{i !== items.length - 1 ? ', ' : ''}</span>
    </span>
  ));
  return <div>{tagNames}</div>;
};

export default TagNames;
